import { Toaster, Position } from '@blueprintjs/core'

export const AppToaster = Toaster.create({
  className: "toaster",
  position: Position.TOP,
});